import i18n from 'es2015-i18n-tag';
import { downloadReport } from '../../report-service';
import './export-report-bar.component.scss';
import { useParams } from 'react-router';

const ExportReportBar = () => {
    const { teamId, surveyRunId } = useParams();

    return (
        <div className="export-report-bar">
            <button
                className="export-report-bar__export-btn"
                onClick={() => downloadReport(teamId, surveyRunId)}
            >
                {i18n('report')`exportieren`}
            </button>
        </div>
    );
};

export default ExportReportBar;
